import React from 'react';
import { Typography, Paper, Box, List, ListItem, ListItemText, Divider } from '@mui/material';
import { useParams } from 'react-router-dom';

const dummyPatients = Array.from({ length: 10 }, (_, i) => `Patient ${i + 1}`);
const dummyServices = Array.from({ length: 10 }, (_, i) => `Service ${i + 1}`);

function ChatPage() {
  const { id } = useParams();
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6">Chat - Log ID: {id}</Typography>
      <Box display="flex" mt={2}>
        <Box width={240} mr={2}>
          <Typography variant="subtitle1">Patients</Typography>
          <List>
            {dummyPatients.map((name, idx) => (
              <ListItem button key={idx}>
                <ListItemText primary={name} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box flex={1} ml={2}>
          <Typography variant="subtitle1">Service List</Typography>
          <List>
            {dummyServices.map((name, idx) => (
              <ListItem button key={idx}>
                <ListItemText primary={name} />
              </ListItem>
            ))}
          </List>
          <Typography mt={2}>Chat and WhatsApp message logic will be implemented here.</Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default ChatPage; 